export const categorySelectFivePlusIntroSteps = [
  {
    element: '.student-dropdown-row:nth-child(1)',
    intro: 'Click here to view all of the connected texts students grade 5+ are reading in the WordFlight System.'
  },
  {
    element: '.student-dropdown-row:nth-child(2)',
    intro: 'Click here to view all of the curriculum packets for students in grades 5+. The curriculum packets include additional comprehension, spelling, phrasing, and fluency practice.'
  },
];